import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './useAuth';

interface RequireAuthProps {
  children: ReactNode;
}

/**
 * Bloqueia render até o bootstrap da sessão concluir; depois exige usuário
 * autenticado. Preserva a rota atual em `state.from` para redirect pós-login.
 */
export function RequireAuth({ children }: RequireAuthProps): JSX.Element {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'bootstrapping') {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
        role="status"
        aria-label="Carregando sessão"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <>{children}</>;
}
